import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Locations stats DTO
 */
@CaslSubject(AppSubjectEnum.LOCATION)
export class LocationsStatsDto extends BaseStatsDto {
  open!: number;
  closed!: number;
}
